import "./Charge.css";

const Charge = () => {
  const data = [
    {
      title: "AD Video AI",
      cost: "100 Credits",
      content: "USD 1.00",
      pay: "1.00",
      gradient: "linear-gradient(135deg, #7C4DFF, #513878)",
      icon: "📢",
    },
    {
      title: "Business Plan AI",
      cost: "415 Credits",
      content: "USD 5.00",
      pay: "5.00",
      gradient: "linear-gradient(135deg, #EF4444, #D62626)",
      icon: "💼",
    },
    {
      title: "Comic Video AI",
      cost: "500 Credits",  
      content: "USD 6.00",
      pay: "6.00",
      gradient: "linear-gradient(135deg, #5C81FD, #3B5FE0)",
      icon: "🎬",
    },
    // {
    //   title: "Social Media Consultant",
    //   cost: "1 Credit per 3000 characters",
    //   content: "USD 0.012",
    //   pay: "0.012",
    //   gradient: "linear-gradient(135deg, #7C4DFF, #513878)",
    //   icon: "🧑‍💼",
    // },
    // {
    //   title: "Developer AI",
    //   cost: "834 Credits",
    //   content: "USD 10.00",
    //   pay: "10.00",
    //   gradient: "linear-gradient(135deg, #0EA5E9, #0284C7)",
    //   icon: "💻",
    // },
    {
      title: "Fact of the day AI",
      cost: "75 Credits",
      content: "USD 0.90",
      pay: "0.90",
      gradient: "linear-gradient(135deg, #0EA5E9, #0284C7)",
      icon: "🎯",
    },
    {
      title: "Image AI",
      cost: "10 Credits",
      content: "USD 0.12",
      pay: "0.12",
      gradient: "linear-gradient(135deg, #1D60EF, #1545B0)",
      icon: "🖼️",
    },
    {
      title: "News Poster AI",
      cost: "75 Credits",
      content: "USD 0.90",
      pay: "0.90",
      gradient: "linear-gradient(135deg, #00d9f1ff, #0c74d1ff)",
      icon: "🖼️",
    },
    {
      title: "Promo Campaign AI",
      cost: "75 Credits",
      content: "USD 0.90",
      pay: "0.90",
      gradient: "linear-gradient(135deg, #FFCA2C, #E5A800)",
      icon: "📢",
    },
    // {
    //   title: "News Video AI",
    //   cost: "35 Credits",
    //   content: "USD 0.42",
    //   pay: "0.42",
    //   gradient: "linear-gradient(135deg, #FFCA2C, #E5A800)",
    //   icon: "📰",
    // },
    {
      title: "Social Post AI",
      cost: "75 Credits",
      content: "USD 0.90",
      pay: "0.90",
      gradient: "linear-gradient(135deg, #D40BF7, #A000C8)",
      icon: "📸",
    },
    {
      title: "Poster Design AI",
      cost: "75 Credits",
      content: "USD 0.90",
      pay: "0.90",
      gradient: "linear-gradient(135deg, #B8860B, #815606)",
      icon: "📸",
    },
    {
      title: "Product Video AI",
      cost: "75 Credits",
      content: "USD 0.90",
      pay: "0.90",
      gradient: "linear-gradient(135deg, #e7e2d4ff, #ff8a79ff)",
      icon: "📸",
    },
    // {
    //   title: "Post AI",
    //   cost: "10 Credits",
    //   content: "USD 0.12",
    //   pay: "0.12",
    //   gradient: "linear-gradient(135deg, #B8860B, #815606)",
    //   icon: "📝",
    // },
    {
      title: "Text AI",
      cost: "1 Credit per 3000 characters",
      content: "USD 0.012",
      pay: "0.012",
      gradient: "linear-gradient(135deg, #05C0A2, #04A88D)",
      icon: "✍️",
    },
    // {
    //   title: "Text Video AI",
    //   cost: "35 Credits",
    //   content: "USD 0.42",
    //   pay: "0.42",
    //   gradient: "linear-gradient(135deg, #EF4444, #D62626)",
    //   icon: "🎥",
    // },
    {
      title: "Toy Stories AI",
      cost: "10 Credits",
      content: "USD 0.12",
      pay: "0.12",
      gradient: "linear-gradient(135deg, #F97316, #EA580C)",
      icon: "🧸",
    },
    {
      title: "Video AI",
      cost: "100 Credits",
      content: "USD 1.20",
      pay: "1.20",
      gradient: "linear-gradient(135deg, #8B5CF6, #7C3AED)",
      icon: "🎥",
    },
    {
      title: "Voice AI",
      cost: "1 Credit per 3000 characters",
      content: "USD 0.012",
      pay: "0.012",
      gradient: "linear-gradient(135deg, #8B5CF6, #7C3AED)",
      icon: "🎙️",
    },
  ];

  return (
    <div className="charge-grid">
      {data
        .sort((a, b) => a.title.localeCompare(b.title))
        .map((item, index) => (
          <div key={index} className="charge-card">
            <div
              className="charge-card-accent"
              style={{ background: item.gradient }}
            />
            <div className="charge-card-body">
              <div
                className="charge-card-icon"
                style={{ background: item.gradient }}
              >
                <span>{item.icon}</span>
              </div>
              <h4 className="charge-card-title">{item.title}</h4>
              <p className="charge-card-credits">{item.cost}</p>
              <div className="charge-card-divider" />
              <p className="charge-card-price-label">Low as</p>
              <p className="charge-card-price">{item.content}<span className="text-danger">*</span></p>
            </div>
          </div>
        ))}
    </div>
  );
};

export default Charge;
